import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import { ListingTile } from './ListingTile';
import styles from './ListingTileWithPopup.module.css';
import PromoPopup from '../../popup/PromoPopup';
import { PromoDangerouslyHtml } from '../promo-dangerously-html/PromoDangerouslyHtml';

const ListingTileWithPopup = (props) => {
    const popupRef = useRef(null);

    return (
        <>
            {props.description !== null ? (
                <ListingTile
                    loadingLazy={props.loadingLazy}
                    img={props.img}
                    title={props.title}
                    subtitle={props.subtitle}
                    onClick={() => {
                        popupRef.current?.open(
                            <div className={styles.popupWrapper}>
                                <ListingTile img={props.img} title={props.title} subtitle={props.subtitle} />
                                <div className={styles.bottomFrame}>
                                    {props.description && <PromoDangerouslyHtml color={'baseColor'} dangerouslyHtml={props.description} tag={'div'} />}
                                </div>
                            </div>,
                        );
                    }}
                />
            ) : (
                <ListingTile
                    loadingLazy={props.loadingLazy}
                    img={props.img}
                    title={props.title}
                    subtitle={props.subtitle}
                    linkText={props.linkText}
                    linkUrl={props.linkUrl}
                />
            )}
            <PromoPopup ref={popupRef} isWidePopup />
        </>
    );
};
ListingTileWithPopup.propTypes = {
    img: PropTypes.array,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string,
    loadingLazy: PropTypes.bool,
};
export default ListingTileWithPopup;
